module.exports = "table, th, td  {\n    border: 0.5px solid gainsboro !important;\n   }\n   \n   "